<template>
  <div class="loading pad text-center has-text-grey-light">
      <div v-if="text" class="pad">{{ text }}</div>
      <font-awesome-icon icon="spinner" :size="size" pulse />
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    size: { default: '3x' },
    text: { default: null }
  }
}
</script>

<style>
  .loading {
    padding: 30px 0 30px;
  }
</style>
